"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalBlock = LegalBlock;
var jsx_runtime_1 = require("react/jsx-runtime");
var text_component_1 = require("../ui/text-component");
function LegalBlock(props) {
    var block = props.block;
    if (block.type === "paragraph") {
        return (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", className: "leading-6", label: block.text });
    }
    return ((0, jsx_runtime_1.jsx)("ul", { className: "flex list-disc flex-col gap-1.5 pl-5 text-sm leading-6 text-medium-gray marker:text-primary-navy", children: block.items.map(function (item) { return ((0, jsx_runtime_1.jsxs)("li", { children: [item.text, item.subItems && ((0, jsx_runtime_1.jsx)("ul", { className: "mt-1.5 flex list-[circle] flex-col gap-1.5 pl-5", children: item.subItems.map(function (subItem) { return ((0, jsx_runtime_1.jsx)("li", { children: subItem }, subItem)); }) }))] }, item.text)); }) }));
}
